import {common} from "../../../global/common.js";

export const GotoSearchMixin = {
	methods: {
		async searchPhysicians(companyId, token) {
			let locationUrl = `ProviderSearch/${companyId}/GetCompanyLocation`;
			locationUrl = common.appendUrlParameter(locationUrl, 'token', token);
			let result = await $.ajax({type: "Get", url: locationUrl});
			this.goToSearchPage(result);
		},

		goToSearchPage({latitude, longitude, address}) {
			const routeQuery = this.$route && this.$route.query ? this.$route.query : {};
			const searchQueryKeys = [
				'planCategoryId',
				'designationId',
				'onlyAcceptingNewPatients',
				'physicianName',
				'addressName',
				'networkId',
			];
			const preservedQuery = {};
			searchQueryKeys.forEach((key) => {
				const value = routeQuery[key];
				if (value !== undefined && value !== null && value !== '') {
					preservedQuery[key] = value;
				}
			});
			this.$router.push({
				name: 'search', params: {
					companyId: this.companyId,
					token: this.token,
					radiusId: 7,
					latitude: latitude,
					longitude: longitude
				},
				query: {
					...preservedQuery,
					onlyAcceptingNewPatients: preservedQuery.onlyAcceptingNewPatients || 1,
					addressName: address || preservedQuery.addressName || ''
				}
			});
		}
	}
}
